import { Injectable } from '@angular/core';
import { TableDataColumn, TableDataColumnFilter, TableDataColumnOrder } from '../models/table.models';

@Injectable()
export class TableQueryService {
  public getQuery(page: number, pageSize: number = 10, orderBy?: TableDataColumn, filters?: TableDataColumnFilter[], search?: string | null): string {
    let query = `page=${page}&pageSize=${pageSize}`;
    let orderQuery = '';
    let filterQuery = '';

    if (orderBy && orderBy.orderable && orderBy.sortOrder !== TableDataColumnOrder.None) {
      const sign = orderBy.sortOrder === TableDataColumnOrder.Desc ? '-' : '';

      orderQuery = `&sorts=${sign}${orderBy.renderColumn}`;
    }

    if (filters && filters.length > 0 && filters.some((x) => x.value !== '')) {
      filterQuery = '&filters=';

      for (const filter of filters) {
        if (filter.value && filter.value !== '') {
          filterQuery += `${filter.columnName}${filter.filterType}${filter.value},`;
        }
      }
    }

    if (orderQuery !== '') {
      query += orderQuery;
    }

    if (filterQuery !== '') {
      query += filterQuery;
    }

    if (search && search !== '') {
      query += `&search=${search}`;
    }

    return query;
  }
}
